import { render } from "./modal-change-period-price.vue?vue&type=template&id=d800220e&scoped=true&ts=true"
import script from "./modal-change-period-price.vue?vue&type=script&lang=ts"
export * from "./modal-change-period-price.vue?vue&type=script&lang=ts"

import "./modal-change-period-price.vue?vue&type=style&index=0&id=d800220e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d800220e"]])

export default __exports__